import { Controller } from "@hotwired/stimulus"

// Click-to-expand for a subtask row's description. Attached to the row's <li>,
// it listens for clicks anywhere on the row and toggles the truncated preview
// into the full, wrapped description. Clicks on interactive controls (checkbox,
// status toggle, edit/delete buttons) are ignored so they keep working.
export default class extends Controller {
  static targets = ["preview", "full", "chevron"]

  toggle(event) {
    if (event.target.closest('a, button, input, label, form, [role="button"]')) {
      return
    }

    const expanded = this.element.getAttribute("aria-expanded") === "true"
    this.setExpanded(!expanded)
  }

  setExpanded(expanded) {
    this.element.setAttribute("aria-expanded", expanded ? "true" : "false")

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.toggle("hidden", expanded)
    }
    if (this.hasFullTarget) {
      this.fullTarget.classList.toggle("hidden", !expanded)
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", expanded)
    }
  }
}
